'use es6';

import PropTypes from 'prop-types';
import { BaseResponsiveHeaderToolbar, buildHeaderActions } from './BaseResponsiveHeaderToolbar';
import { jsx as _jsx } from "react/jsx-runtime";
const MockResponsiveMobileHeaderToolbar = ({
  responsiveSize,
  isInNonDefaultBreakpointMode
}) => {
  return /*#__PURE__*/_jsx(BaseResponsiveHeaderToolbar, {
    actions: buildHeaderActions({
      isInNonDefaultBreakpointMode
    }),
    responsiveSize: responsiveSize
  });
};
MockResponsiveMobileHeaderToolbar.propTypes = {
  responsiveSize: PropTypes.string.isRequired,
  isInNonDefaultBreakpointMode: PropTypes.bool.isRequired
};
const MockResponsiveDesktopHeaderToolbar = ({
  responsiveSize
}) => {
  return /*#__PURE__*/_jsx(BaseResponsiveHeaderToolbar, {
    actions: buildHeaderActions({}),
    responsiveSize: responsiveSize
  });
};
MockResponsiveDesktopHeaderToolbar.propTypes = {
  responsiveSize: PropTypes.string.isRequired
};
export { MockResponsiveDesktopHeaderToolbar, MockResponsiveMobileHeaderToolbar };